import { mergeStyleSets } from '@uifabric/merge-styles';
import { Depths } from '@uifabric/fluent-theme';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.neutralWhite,
    boxShadow: Depths.depth4,
    position: 'absolute',
    left: 0,
    top: '2rem',
    width: '100%',
  },
  moreResults: {
    paddingTop: pxToRem(15),
    paddingBottom: pxToRem(15),
    paddingLeft: pxToRem(12),
    fontSize: 14,
    color: theme.palette.themePrimary,
  },
  loadingSpinner: {
    marginTop: pxToRem(16),
    marginBottom: pxToRem(16),
    paddingLeft: pxToRem(30),
    paddingRight: pxToRem(30),
  },
  noResultsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: pxToRem(16),
    whiteSpace: 'pre-wrap',
  },
  noResultsLabel: {
    fontSize: pxToRem(14),
    fontWeight: 600,
    color: theme.palette.black,
  },
  noResultsDescription: {
    marginTop: pxToRem(5),
    fontSize: pxToRem(14),
    fontWeight: 400,
    color: theme.palette.black,
  },
  sectionHeader: {
    padding: pxToRem(12),
    fontWeight: 'bold',
    fontSize: pxToRem(14),
  },
  errorContainer: {
    overflow: 'hidden',
    backgroundColor: theme.palette.accentErrorOpaque,
    maxWidth: '400px',
    padding: pxToRem(5),
  },
  messageContainer: {
    overflow: 'hidden',
    maxWidth: '400px',
    padding: pxToRem(5),
  },
});
